import { render, staticRenderFns } from "./UnderReviewSearchBar.vue?vue&type=template&id=576f10a4&scoped=true&"
import script from "./UnderReviewSearchBar.vue?vue&type=script&lang=js&"
export * from "./UnderReviewSearchBar.vue?vue&type=script&lang=js&"
import style0 from "./UnderReviewSearchBar.vue?vue&type=style&index=0&id=576f10a4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "576f10a4",
  null
  
)

export default component.exports